import React, { useContext, useEffect, useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Typography,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Alert,
} from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number';
import SigninPageContentLayout from 'app/design/layouts/SigninPageContentLayout';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import * as Yup from 'yup';
import 'yup-phone';
import { Formik } from 'formik';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MuiButton from 'app/design/uiComponents/MuiButton';
import {
  getQueryParam,
  parseFormattedPhoneNumber,
} from 'utils/GenericFunctions';
import { DEFAULT_COUNTRY_CODE } from 'constants/common';
import DoneIcon from '@mui/icons-material/Done';
// import { FEATURES } from 'types/Feature';
// import _ from 'lodash';
// service
import useMobileSignup from 'services/Auth/useMobileSignup';
import { logFirebaseEventEntry } from 'utils/firebaseAnalyticsUtils';
import useGetSiteInfo from 'services/common/useGetSiteInfo';
import useReferralValidate from 'services/Auth/useReferralValidate';
// import { FeatureFlag } from 'app/components/Common/FeatureFlag';
// import { checkFeatureStatus } from 'app/components/Common/FeatureFlag/featureChecker';
import { useIsFeatureFlag } from 'app/components/Common/FeatureFlag';
import { FEATURES } from 'types/Feature';
import { useGetMediaQueryUp } from 'app/hooks/useGetMediaQuery';
import { themeContext } from '../Context/ToggleThemeContext';
interface ObjProps {
  ccode: string;
  pnum: string;
  password: string;
  email: string;
}
export function SignUpNoOtp({
  handleClose,
  onAuthPageChange
}: {
  handleClose: () => void;
  onAuthPageChange: (view: string) => void;
}) {
  const { isDarkTheme } = useContext(themeContext);
  const isMdUp = useGetMediaQueryUp('md');
  const { data: siteInfo } = useGetSiteInfo();

  const handleOkClick = () => {
    handleClose();
    onAuthPageChange('Sign In');
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Signup Success Page</title>
        <meta name="description" content="Signup success page" />
      </Helmet>
      <SigninPageContentLayout>
        {/* Must have max two child element */}
        <Box sx={{ maxWidth: '20rem', marginX: { md: 'auto', sm: 'auto' } }}>
          {!isMdUp && (
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              {siteInfo && siteInfo.logo && (
                <RouterLink to="/">
                  <img
                    src={
                      isDarkTheme ? siteInfo.speedbot_dark_logo : siteInfo.logo
                    }
                  />
                </RouterLink>
              )}
            </Box>
          )}
          <Alert sx={{ my: 2 }} severity="error">
            We’ve received your sign-in request. Our team will review it and get
            back to you shortly. If you have any questions in the meantime, feel
            free to reach out to us.
          </Alert>
          {/* </FeatureFlag> */}
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            mb: 2,
            alignItems: 'center',
          }}
          textAlign="center"
        >
          <MuiButton
            className="loginflowBtn"
            size="large"
            variant="contained"
            color="secondary"
            fullWidth={true}
            // component={RouterLink}
            // to={
            //   // process.env.IS_GOOGLE_USER_ENABLE
            //   //   ? `/signup?ref=${queryParam}`
            //   //   : `/signin?ref=${queryParam}`
            //   undefined
            // }
            onClick={() => handleOkClick()}
            sx={{ mt: 2 }}
          >
            <FormattedMessage id="ok" />
          </MuiButton>
        </Box>
      </SigninPageContentLayout>
    </React.Fragment>
  );
}

export default SignUpNoOtp;
